export function showResultSummary(elem) {
    const resultsContainer = elem;
    if (!resultsContainer) return;

    const resultCheck = resultsContainer.querySelector(".results__check");
    const resultSummary = resultsContainer.querySelector(".results__summary");
    const showScore = resultsContainer.querySelector(".result-count");
    const showTotal = resultsContainer.querySelector(".questions-count");
    const waveProgress = resultsContainer.querySelector(".wave-progress");
    

    console.log(waveProgress)

    const storedResults = localStorage.getItem("quizResults");

    if (!storedResults) {
        resultCheck.classList.remove("hidden");
        return;
    }

    const { score, total } = JSON.parse(storedResults);

    resultSummary.classList.remove("hidden");
    showScore.textContent = score;
    showTotal.textContent = total;
}
